import React, { useEffect, useState } from 'react';

import { defaultOutageStatusResponse, getOutageStatus } from '../../Outage/api';
import MaintenancePage from '../Maintenance';

interface MaintenanceGuardProps {
  children: React.ReactNode;
  authState?: string;
}

function MaintenanceGuard({ children, authState }: MaintenanceGuardProps) {
  const [outage, setOutage] = useState(defaultOutageStatusResponse);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getOutageStatus()
      .then((data) => setOutage(data))
      .catch(() => {}) // on error, assume no outage
      .finally(() => setLoading(false));
  }, [authState]);

  // 1) still loading → render nothing (or spinner if you prefer)
  if (loading) return null;

  // 2) relational‑DB in maintenance → full‑page takeover
  if (outage.is_relational_outage) {
    return <MaintenancePage />;
  }

  // 3) otherwise let the real app render
  return <>{children}</>;
}

export default MaintenanceGuard;
